import { Trans } from '@lingui/react/macro';
import type { PaginatedResponseOfInspectionSessionRecord } from '@navio/nsdk';
import { NoddiBasicCard, NoddiSkeleton } from 'noddi-ui-web';
import { InspectionCard, inspectionCardPropsFromSession } from 'noddi-web';
import { getCommonTranslations, getWheelLabels } from '../../../utils/commonTranslations';

interface Props {
  carInspections: PaginatedResponseOfInspectionSessionRecord | undefined;
  isLoading: boolean;
}

export const CarInspections = ({ carInspections, isLoading }: Props) => {
  if (isLoading) {
    return (
      <div className='flex flex-col gap-4'>
        <h3 className='text-xl font-bold text-primary md:text-3xl'>
          <Trans>Inspections</Trans>
        </h3>
        <NoddiSkeleton className='h-24 w-full' />
        <NoddiSkeleton className='h-24 w-full' />
      </div>
    );
  }

  if (!carInspections?.results || carInspections.results.length === 0) {
    return (
      <div className='flex flex-col gap-4'>
        <h3 className='text-xl font-bold text-primary md:text-3xl'>
          <Trans>Inspections</Trans>
        </h3>
        <NoddiBasicCard>
          <div className='flex flex-col items-center justify-center py-12 text-center'>
            <div className='text-sm text-muted-foreground'>
              <Trans>No inspection data available for this car</Trans>
            </div>
          </div>
        </NoddiBasicCard>
      </div>
    );
  }

  const commonTranslations = getCommonTranslations();
  const wheelLabels = getWheelLabels();

  return (
    <div className='flex flex-col gap-4'>
      <h3 className='text-xl font-bold text-primary md:text-3xl'>
        <Trans>Inspections</Trans>
      </h3>

      <div className='flex flex-col gap-5'>
        {carInspections.results.map((session) => (
          <InspectionCard
            key={session.id}
            {...inspectionCardPropsFromSession(session, wheelLabels)}
            translations={commonTranslations.inspectionCard}
            seasonBadgeTranslations={commonTranslations.seasonBadge}
          />
        ))}
      </div>
    </div>
  );
};
